// Add channel
export const ADD_NEW_CHANNEL = "ADD_NEW_CHANNEL"
export const ADD_CHANNEL_SUCCESS = "ADD_CHANNEL_SUCCESS"
export const ADD_CHANNEL_FAIL = "ADD_CHANNEL_FAIL"
export const CLEAR_CHANNEL_STATE = "CLEAR_CHANNEL_STATE"

